module.exports = __webpack_public_path__ + "static/builder-one@2x-f56b0fd49169ebf00b44a4dd1f30180d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/ios-app-builder/builder-one@2x.jpg
// module id = 2650
// module chunks = 168707334958949